import { ResultLinkConfig } from '../models/result-link-config.model';

export const RESULT_LINK_CONFIGS: ResultLinkConfig[] = [
  // Romanian labels
  {
    facetKey: 'type',
    matchMode: 'label',
    values: ['Pagina informativa'],
    urlTemplate: '/ro/e/templatepaginainformativav4/549159/{id}',
    openInNewTab: false
  },
  {
    facetKey: 'type',
    matchMode: 'label',
    values: ['Procedura'],
    urlTemplate: '/ro/e/servicii/549159/{id}',
    openInNewTab: false
  },
  {
    facetKey: 'type',
    matchMode: 'label',
    values: ['Institutie'],
    urlTemplate: '/ro/e/institutie/549157/{id}',
    openInNewTab: false
  },
  // English labels (translations)
  {
    facetKey: 'type',
    matchMode: 'label',
    values: ['Information Page'],
    urlTemplate: '/en/e/templatepaginainformativav4/549159/{id}',
    openInNewTab: false
  },
  {
    facetKey: 'type',
    matchMode: 'label',
    values: ['Procedure'],
    urlTemplate: '/en/e/servicii/549159/{id}',
    openInNewTab: false
  },
  {
    facetKey: 'type',
    matchMode: 'label',
    values: ['Institution'],
    urlTemplate: '/en/e/institution/549157/{id}',
    openInNewTab: false
  }
];
